<div class="containar-layout team-section" *ngIf="teamDetails.length">
  <table class="table-section">
    <thead>
      <tr>
        <th class="column-head custom-border">Teams ( <span
            *ngFor="let teamShiftDetail of teamDetails[0]?.teamShiftDetails">{{teamShiftDetail?.dateStr |
            weekMonthDate}}</span>)</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let shiftDetail of teamDetails">
        <ng-container *ngFor="let teamShiftDetail of shiftDetail?.teamShiftDetails">
          <div class="main-card slot-card-wrapper {{teamShiftDetail?.openShiftRequestStatus ===  810 ? 'published' : teamShiftDetail?.openShiftRequestStatus ===  820 ? 'inprogress' : '' }}">
            <div class="unavailable-card" [ngClass]="bgUnavailable[teamShiftDetail?.teamStatus]">
              <span class="column-body"><ng-container
                  *ngTemplateOutlet="teamHeader; context: shiftDetail"></ng-container></span>
              <span class="column-body">
                <span class="column-body"
                  *ngFor="let teamShiftMember of teamShiftDetail?.teamShiftMembers"><app-team-day-slot-card
                    [teamShiftDetail]="teamShiftMember"
                    (openShiftPopup)="openShift($event)"></app-team-day-slot-card></span>
                <div class="unavailable">
                  <span class="unavailable-text" *ngIf="teamShiftDetail.teamShiftMembers.length === 0">
                    <div class="icons"><img src="/assets/images/temp/calendar-cancel.svg" alt="no calendar invite" />
                    </div>
                    <span class="unavailable-heading" translate>label_unavailable</span>
                  </span>
                </div>
              </span>
              <ng-template #teamHeader let-teamName="teamName" let-teamShifts="teamShifts" let-providerId="providerId" let-id="id">
                <div class="team-header-wrappper">
                  <h4 class="title-heading">{{teamName}}
                    <span class="text" *ngFor="let teamShift of manageTeamShifts(teamShifts); last as isLast">
                      <span>{{teamShift?.shiftSchedule}}</span>
                      <span> {{teamShift?.startTimeStr}} - {{teamShift?.endTimeStr}} <span *ngIf="!isLast && +teamShift?.endDate == -1">
                          |</span></span>
                      <span *ngIf="+teamShift?.endDate != -1"> Ends on: {{teamShift?.endDateTimeStr}} <span *ngIf="!isLast">
                        |</span></span>
                    </span>
                    <span class="text blue-text" *ngIf="teamShifts.length > 2"
                      (click)="toggleOverviewPanel($event, teamShifts)">more</span>
                    <span class="right-wrapper">
                      <span class="icon" (click)="goToEdit(teamShiftDetail?.dateStr,shiftDetail)" pTooltip="Edit team"
                        tooltipPosition="top" tooltipStyleClass="custom-tooltip" *ngIf="!isPastDate">
                        <img src="/assets/images/temp/edit-req.png" alt="edit icon" style="height: 20px;" class="edit-icon" /></span>
                      <span class="icon" (click)="openShift(teamShiftDetail, shiftDetail?.id)" pTooltip="Publish open shift" tooltipPosition="top"
                        tooltipStyleClass="custom-tooltip"><img src="/assets/images/temp/shift.svg"
                          alt="shift icon" *ngIf="isOpenShiftPermission && globalConfigOS && !isPastDate && !organizationLevelDispatch && !providerLevelDutyArr.includes(providerId) && !teamLevelDutyArr.includes(id)"/></span>
                    </span>
                  </h4>
                </div>
              </ng-template>
            </div>
          </div>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>
<div class="no-records-wrapper" *ngIf="!teamDetails.length" translate>label_shift_no_records_available</div>

<p-dialog [blockScroll]="true" modal="true" [showHeader]="false" position="center" responsive="true"
  styleClass="medium-popup" [(visible)]="hasShowPublishShiftPopUp" [style]="{width: '450px', height: 'auto'}"
  responsive="true" ng-style="overflow: auto" [contentStyle]="{'overflow':'auto'}">
  <app-publish-open-shift (publishOpenShiftEmitter)="onClickOfPopupButton($event)" [selectedTeam]="selectedTeam"
    [selectedDate]="selectedDate"></app-publish-open-shift>
</p-dialog>

<p-overlayPanel class="grid-overlay-panel" [showCloseIcon]="true" #op>
  <div class="text team-header-inner-wrappper" *ngFor="let teamShift of teamShiftsList">
    <div class="slot-main-wrapper">
      <span class="text team-schedule">{{teamShift?.shiftSchedule}}</span>
      <span class="text">{{teamShift?.startTimeStr}}-{{teamShift?.endTimeStr}}</span>
    </div>
    <div class="custom-date-wrapper" *ngIf="+teamShift?.endDate != -1">
      <span class="text bold" translate>label_shift_ends_on</span>
      <span class="text">{{teamShift?.endDateTimeStr}}</span>
    </div>
  </div>
</p-overlayPanel>
